import { normalizeApiError } from "../../../../lib/result-codes";

export const getFirstMerchantCouponApiErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  const response = normalizeApiError<unknown>(error, fallback);
  const firstError = response.errors[0];

  return (
    firstError?.user_message ??
    firstError?.message ??
    firstError?.detail ??
    response.user_message ??
    response.message ??
    fallback
  );
};
